import $ from "jquery";

$(document).on("turbolinks:load ", () => {
  var tr = $("<tr role='row'>");
  var thead = $(".table-with-top-header").find("thead");
  var topHeaders = $("#top-headers")[0];
  if (!topHeaders) return;
  topHeaders = topHeaders.attributes;
  $.each(topHeaders, function(name, value) {
    var attribute = value.value.split("::");
    if (attribute.length > 1) {
      var title = attribute[0];
      var colspan = attribute[1];
      tr.append("<th style='position:relative !important' class='col-string col-col1' colspan=" + colspan + "><span class='filter-label'>" + title + "</span></th>");
    }
  });
  thead.prepend(tr);
});
